import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function PublicNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-content">
          <div className="navbar-left">
            <Link to="/" className="navbar-brand" style={{ textDecoration: 'none', color: 'white', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src="/logo.svg" alt="Options Tracker Logo" style={{ width: '32px', height: '32px' }} />
              <span>Options Tracker</span>
            </Link>
            <button
              className="mobile-menu-toggle"
              onClick={() => setMobileMenuOpen(o => !o)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className="navbar-right public-nav-actions">
            <Link to="/calculators" className="btn btn-secondary">Free Tools</Link>
            <Link to="/blog" className="btn btn-secondary">Blog</Link>
            <Link to="/pricing" className="btn btn-secondary">Pricing</Link>
            <Link to="/login" className="btn btn-secondary">Login</Link>
            <Link to="/register" className="btn btn-primary">Sign Up</Link>
          </div>
        </div>
      </nav>

      {/* Mobile overlay */}
      <div
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />

      {/* Mobile sidebar */}
      <div className={`mobile-menu-sidebar ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <Link to="/" className="navbar-brand" style={{ textDecoration: 'none', color: 'white', display: 'flex', alignItems: 'center', gap: '10px' }} onClick={closeMobileMenu}>
            <img src="/logo.svg" alt="Options Tracker Logo" style={{ width: '28px', height: '28px' }} />
            <span>Options Tracker</span>
          </Link>
          <button className="mobile-close-btn" onClick={closeMobileMenu} aria-label="Close menu">×</button>
        </div>
        <div className="mobile-menu-content">
          <div className="navbar-links">
            <Link to="/calculators" onClick={closeMobileMenu}>Free Tools</Link>
            <Link to="/blog" onClick={closeMobileMenu}>Blog</Link>
            <Link to="/pricing" onClick={closeMobileMenu}>Pricing</Link>
          </div>
          <div className="mobile-menu-divider"></div>
          <div className="navbar-links navbar-links-secondary">
            <Link to="/login" onClick={closeMobileMenu}>Login</Link>
            <Link to="/register" onClick={closeMobileMenu}>Sign Up</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default PublicNavbar;
